var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 47.41,
    y1: 38.9,
    x2: 35.75,
    y2: 22.06,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.98,
    y1: 38.9,
    x2: 133.22,
    y2: 18.63,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.99,
    y1: 38.9,
    x2: 99.08,
    y2: 9.53,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.77,
    y1: 41.29,
    x2: 63.18,
    y2: 10.75,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.34,
    y1: 49.85,
    x2: 17.04,
    y2: 41.29,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.25,
    y1: 56.91,
    x2: 144.71,
    y2: 47.57,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80,119.55h51.4l5-4V90.28c.27-8.92-8.86-16.28-8.86-16.28H80",
    fill: "#999",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.51,119.55h57.87l5-4V90.28c.27-8.92-8.86-16.28-8.86-16.28",
    fill: "#666",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.39,
    y: 97.42,
    width: 15.99,
    height: 32,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,45.28h27.54c11.91,0,20,28.72,20,28.72H80",
    fill: "#d1f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,57.73h12a12,12,0,0,1,3,8.12H94A12,12,0,0,1,97,57.73Z",
    fill: "#0af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,65.85h24A12,12,0,0,1,118,74H88A12,12,0,0,1,91,65.85Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,65.85H117S125,69.8,125,74H80",
    fill: "#0af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,74H126l-1-8.12h11A10.81,10.81,0,0,1,140,74Z",
    fill: "#999",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,45.28h27.54c11.91,0,20,28.72,20,28.72H80",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,90.28v29.27h51.4l5-4V92.28s-.25-5-17.4-5l-39-1Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "79.98 119.55 131.38 119.55 136.38 115.55 136.38 90.28",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.52,
    y1: 111,
    x2: 79.98,
    y2: 111,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.34,
    y: 93.28,
    width: 17.18,
    height: 13.52,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.2,
    y1: 93.35,
    x2: 79.98,
    y2: 93.35,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.2,
    y1: 105.35,
    x2: 79.98,
    y2: 105.35,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.2,
    y1: 101.35,
    x2: 79.98,
    y2: 101.35,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.2,
    y1: 97.35,
    x2: 79.98,
    y2: 97.35,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.93,
    y1: 105.8,
    x2: 127.93,
    y2: 94.28,
    fill: "#fff",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80,119.55H28.62l-5-4V90.28C23.35,81.36,32.48,74,32.48,74H80",
    fill: "#999",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.49,119.55H28.62l-5-4V90.28C23.35,81.36,32.48,74,32.48,74",
    fill: "#666",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.62,
    y: 97.42,
    width: 15.99,
    height: 32,
    transform: "translate(71.23 226.83) rotate(-180)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,45.28H52.48c-11.91,0-20,28.72-20,28.72H80",
    fill: "#d1f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.05,57.73h-12a12,12,0,0,0-3,8.12h18A12,12,0,0,0,63.05,57.73Z",
    fill: "#0af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.05,65.85h-24a12,12,0,0,0-3,8.12h30A12,12,0,0,0,69.05,65.85Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,65.85H43s-7.91,4-7.91,8.15H80",
    fill: "#0af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,74H34l1-8.12H24A12,12,0,0,0,21,74Z",
    fill: "#999",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,45.28H52.48c-11.91,0-20,28.72-20,28.72H80",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,90.28v29.27H28.62l-5-4V92.28s.25-5,17.4-5l39-1Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "80.02 119.55 28.62 119.55 23.62 115.55 23.62 90.28",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.48,
    y1: 111,
    x2: 80.02,
    y2: 111,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.48,
    y: 93.28,
    width: 17.18,
    height: 13.52,
    transform: "translate(76.14 200.08) rotate(-180)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.8,
    y1: 93.35,
    x2: 80.02,
    y2: 93.35,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.8,
    y1: 105.35,
    x2: 80.02,
    y2: 105.35,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.8,
    y1: 101.35,
    x2: 80.02,
    y2: 101.35,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.8,
    y1: 97.35,
    x2: 80.02,
    y2: 97.35,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.07,
    y1: 105.8,
    x2: 32.07,
    y2: 94.28,
    fill: "#fff",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "72.52 51.82 80.1 51.82 87.68 51.82",
    fill: "none",
    stroke: "#0af",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.52,
    y1: 89.25,
    x2: 83.68,
    y2: 89.25,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "80.1 48.86 80.1 51.82 80.1 51.82",
    fill: "none",
    stroke: "#0af",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.99 121.81 69.43 121.81 69.31 109.3 90.86 109.3 90.99 121.81",
    fill: "#ffea80",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.81,
    y1: 115.55,
    x2: 86.49,
    y2: 115.55,
    fill: "none",
    stroke: "#ffd500",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "4 1.5 2 1.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.66,
    y1: 68.69,
    x2: 91.49,
    y2: 68.69,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.37,
    y1: 72.71,
    x2: 109.18,
    y2: 68.71,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.54,
    y1: 68.19,
    x2: 80.71,
    y2: 68.19,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.91,
    y1: 72.71,
    x2: 70.71,
    y2: 68.21,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarGoal);
export default __webpack_public_path__ + "static/media/car-goal.19b78c42.svg";
export { ForwardRef as ReactComponent };